const newsletter = `
# eBL Newsletter 11

## 28 October 2022

### Fragmentarium & Signs

- The platform is now called electronic Babylonian Library. The platform will be
  adapted as a hub for projects, based around the Corpus and the Fragmentarium.
- It is now possible to restrict access to fragments to certain users. At the
  moment, the following scopes have been created: Sippar Library, CAIC project,
  and LBU Uruk.
- It is now possible to submit corrections to texts in Corpus and Fragmentarium.
- Page numbers in inline bibliographical references (@bib{george2003epic@123})
  are no longer mandatory.
- Introductions to fragments can now be entered, see e.g.
  [IM.67539](https://www.ebl.lmu.de/fragmentarium/IM.67539)

### Corpus

- Display mode for Corpus search is now completely implemented.
- Dictionary pages now show the first 10 instances of a lemma in Corpus editions.

### Website launch & Workshop

- We strive to open [www.ebl.lmu.de](http://www.ebl.lmu.de/) to the public in
  January 2023.
- We would like to celebrate the launch with a workshop, which will take place in
  Munich on the 3rd of February 2023 in a hybrid format. We will announce the
  conference to the general public further down the line.`

export default newsletter
